var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "breadcrumb" } },
    [
      _vm.$route.path !== "/"
        ? _c(
            "router-link",
            { attrs: { to: "/" } },
            [
              _vm.dashboard.icon
                ? _c("Icon", {
                    staticClass: "icon",
                    attrs: { type: _vm.dashboard.icon },
                  })
                : _vm._e(),
              _vm._v(_vm._s(_vm.dashboard.name) + "\r\n  "),
            ],
            1
          )
        : _vm._e(),
      _c(
        "transition-group",
        { attrs: { name: "breadcrumb" } },
        _vm._l(_vm.breadcrumb, function (elem) {
          return _c(
            "span",
            { key: elem.path },
            [
              _vm.$route.path !== "/"
                ? _c("span", { staticClass: "separator" }, [_vm._v("/")])
                : _vm._e(),
              elem.icon
                ? _c("Icon", {
                    staticClass: "icon",
                    attrs: { type: elem.icon },
                  })
                : _vm._e(),
              _vm._v(_vm._s(elem.name) + "\r\n    "),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "span",
        { staticClass: "separator", staticStyle: { "font-size": "14px" } },
        [
          _vm._v(
            "   \r\n    " +
              _vm._s(
                _vm.userInfo.institution && _vm.userInfo.institution.name
                  ? _vm.userInfo.institution.name +
                      (_vm.userInfo.institution &&
                      _vm.userInfo.institution.subordinate &&
                      _vm.userInfo.institution.subordinate.length > 0
                        ? "-" + _vm.userInfo.institution.subordinate
                        : "")
                  : ""
              ) +
              "\r\n  "
          ),
        ]
      ),
      _c(
        "span",
        { staticClass: "separator", staticStyle: { "font-size": "14px" } },
        [
          _vm._v(
            _vm._s(
              _vm.userInfo.institution && _vm.userInfo.institution.doctor
                ? _vm.userInfo.institution.doctor
                : ""
            )
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }